import { render, staticRenderFns } from "./Columnar.vue?vue&type=template&id=29fa203d&scoped=true"
import script from "./Columnar.vue?vue&type=script&lang=js"
export * from "./Columnar.vue?vue&type=script&lang=js"
import style0 from "./Columnar.vue?vue&type=style&index=0&id=29fa203d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fa203d",
  null
  
)

export default component.exports